var React = require('react');

function Cabas (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.5 9h17l-2 11.2a1 1 0 0 1-1 .8H6.5a1 1 0 0 1-1-.8z","key":0}),React.createElement("path",{"d":"M8 9a4 4 0 0 1 8 0","key":1}),React.createElement("path",{"d":"M7.5 12.5v4.5","key":2}),React.createElement("path",{"d":"M16.5 12.5v4.5","key":3})]);
}

Cabas.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Cabas;

Cabas.default = Cabas;
